import { memo, useEffect, useState } from 'react';

import { Col, Divider, Row, Select } from 'antd';

import { CheckOutlined } from '@ant-design/icons';

import { LIMIT_OPTIONS, PLANS_PERIOD } from '../../../constants/subscription';

import AppModal from '../../../components/AppModal';

import styles from './styles.module.scss';

const SubmitSubscriptionModal = ({ isUpdate, isOpen, onCancel, onSubmit, plan, title, isEditDisabled, cancelText }) => {
  const [period, setPeriod] = useState({ value: 1, label: 1 });
  const [limits, setLimits] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);

  const handlePeriodChange = (value, option) => {
    setPeriod(option);
  };

  const onSubmitClick = () => {
    onSubmit(period.value, limits, isUpdate);
  };

  useEffect(() => {
    const initialLimits = {};
    plan?.feature_options?.forEach(item => {
      if (item.limited) {
        initialLimits[item.type] = item.count;
      }
    });

    setLimits(initialLimits);
    setPeriod({ value: plan.period || 1, label: plan.period || 1 });
  }, [plan]);

  useEffect(() => {
    const totalPrice = plan?.feature_options?.reduce((prev, current) => {
      let limitMultiplier = 1;
      if (current.limited) {
        limitMultiplier = limits[current.type] / current.price_limit;
      }
      const price = current.price * period.value * limitMultiplier;
      return prev + price;
    }, 0);

    setTotalPrice(totalPrice);
  }, [period.value, limits]);

  return (
    <AppModal
      confirmButtonText="Select"
      title={title || 'Select subscription period and feature limits'}
      cancelButtonHidden={!onCancel}
      cancelButtonText={cancelText || 'Cancel'}
      confirmButtonHidden={!onSubmit}
      isOpen={isOpen}
      handleCancel={onCancel}
      handleConfirm={onSubmitClick}>
      <div className="py-4">
        <Row className="mb-3 align-items-center">
          <Col span={8}>Plan:</Col>
          <Col span={16} className="text-center font-medium">
            {plan.title}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col span={8}>Period (month):</Col>
          <Col span={16}>
            <Select
              className="w-full"
              // disabled={isEditDisabled}
              disabled
              value={period}
              onChange={handlePeriodChange}
              options={PLANS_PERIOD.map(v => ({ label: v, value: v }))}
            />
          </Col>
        </Row>
        <Divider />
        {plan?.feature_options?.map(feature => (
          <Row className={styles['feature-row']} key={feature.title}>
            <Col span={8}>{feature.title}</Col>
            {feature.limited ? (
              <Col span={16}>
                <Select
                  className="w-full"
                  // disabled={isEditDisabled}
                  disabled
                  value={{
                    label: limits[feature.type],
                    value: limits[feature.type]
                  }}
                  onChange={(value, option) => {
                    setLimits({
                      ...limits,
                      [feature.type]: option.value
                    });
                  }}
                  options={LIMIT_OPTIONS[feature.type]?.map(v => ({ label: v, value: v }))}
                />
              </Col>
            ) : (
              <Col span={16} className="text-center">
                <CheckOutlined style={{ color: '#51AE32' }} />
              </Col>
            )}
          </Row>
        ))}
        <Divider />
        <Row className="align-items-center">
          <Col span={8} className="font-medium">
            Total price:
          </Col>
          <Col span={16} className="text-center font-medium">
            ${totalPrice}
          </Col>
        </Row>
      </div>
    </AppModal>
  );
};

export default memo(SubmitSubscriptionModal);
